import styled from 'styled-components';
import _ from 'lodash';

import { spacing } from 'ui/theme/utils';

const alts = [
  {
    keywords: ['plus', 'plus-white'],
    alt: 'add',
  },
  {
    keywords: ['trash'],
    alt: 'remove',
  },
  {
    keywords: ['eye'],
    alt: 'view',
  },
  {
    keywords: ['unlink-2'],
    alt: 'unlink',
  },
];

const IconComponent = ({ icon, src, alt, ...rest }) => {
  if (_.isFunction(icon)) {
    const Component = icon;
    return <Component {...rest} />;
  }

  if (!src) {
    src = `/assets/img/icons/${icon}.svg`;
    alt = alt || alts.find((item) => item.keywords.includes(icon))?.alt || icon;
  }

  return <img src={src} alt={alt} {...rest} />;
};

export const Icon = styled(IconComponent)`
  width: ${({ width = 'auto', size }) => size || width};
  height: ${({ height = 'auto', size }) => size || height};
  ${(props) => spacing(props)}
`;
